// auto generated in scripts/sync-initial-stats.ts, don't change manually

export const novosibirskConfig = {
    header: {
        items: [
            {
                id: 'DEFAULT',
                displayName: 'Частным лицам',
                displayNameMobile: 'Для всех',
                device: { desktop: true, mobile: true },
                path: '/novosibirsk/',
                icon: '',
                dropdownMenu: [
                    {
                        id: '6759450a852e8ac9d214a6bb',
                        displayName: 'Новостройки',
                        device: { desktop: true, mobile: true },
                        url: '/novosibirsk/novostroyki/',
                        icon: 'm2-magnifier',
                    },
                    {
                        id: '6345648ac4af4b264e895b89',
                        displayName: 'Ипотека',
                        device: { desktop: true, mobile: true },
                        icon: 'm2-percentage-circle',
                        exact: true,
                        dropdownMenu: [
                            {
                                id: '64e8ad903ebc9e513bbf6d5f',
                                displayName: 'Подать заявку',
                                device: { desktop: true, mobile: true },
                                path: '/ipoteka/',
                                icon: '',
                                exact: true,
                            },
                            {
                                id: '64e8ada43ebc9e513bbf6d60',
                                displayName: 'Ипотечный калькулятор',
                                device: { desktop: true, mobile: true },
                                path: '/ipoteka/calculator/',
                                icon: '',
                            },
                            {
                                id: '65705a315216331f9d89bd97',
                                displayName: 'Ипотека на строительство дома',
                                device: { desktop: true, mobile: true },
                                path: '/ipoteka/stroitelstvo-doma/',
                                icon: '',
                                exact: true,
                            },
                            {
                                id: '657059a15216331f9d89bd90',
                                displayName: 'Семейная ипотека',
                                device: { desktop: true, mobile: true },
                                path: '/ipoteka/semeinaya-ipoteka/',
                                icon: '',
                                exact: true,
                            },
                            {
                                id: '657059b35216331f9d89bd91',
                                displayName: 'Рефинансирование ипотеки',
                                device: { desktop: true, mobile: true },
                                path: '/ipoteka/refinansirovanie-ipoteki/',
                                icon: '',
                                exact: true,
                            },
                            {
                                id: '657059d95216331f9d89bd94',
                                displayName: 'Ипотека с господдержкой',
                                device: { desktop: true, mobile: true },
                                path: '/ipoteka/lgotnaya-s-gospodderzhkoy/',
                                icon: '',
                                exact: true,
                            },
                            {
                                id: '657059fa5216331f9d89bd95',
                                displayName: 'Ипотека на первичное жильё',
                                device: { desktop: true, mobile: true },
                                path: '/ipoteka/na-zhile-na-pervichnom-rynke/',
                                icon: '',
                                exact: true,
                            },
                            {
                                id: '65705a1a5216331f9d89bd96',
                                displayName: 'Ипотека на вторичное жильё',
                                device: { desktop: true, mobile: true },
                                path: '/ipoteka/na-zhile-na-vtorichnom-rynke/',
                                icon: '',
                                exact: true,
                            },
                        ],
                    },
                    {
                        id: '6345651dc4af4b264e895b8c',
                        displayName: 'Сделка',
                        device: { desktop: true, mobile: true },
                        path: '/services/deal/',
                        icon: 'house-plus',
                    },
                    {
                        id: 'yuridicheskie-servisi',
                        displayName: 'Юридические сервисы',
                        device: { desktop: true, mobile: true },
                        icon: '',
                        dropdownMenu: [
                            {
                                id: 'zaschita-sdelki',
                                displayName: 'Защита сделки',
                                device: { desktop: true, mobile: true },
                                path: '/services/guaranteed-deal/',
                                icon: '',
                            },
                            {
                                id: 'ekspress-proverka',
                                displayName: 'Экспресс-проверка',
                                device: { desktop: true, mobile: true },
                                path: '/services/checkup/',
                                icon: '',
                            },
                            {
                                id: 'proverka',
                                displayName: 'Проверка недвижимости',
                                device: { desktop: true, mobile: true },
                                path: '/services/proverka-yuridicheskoy-chistoty-kvartiry/',
                                icon: '',
                            },
                            {
                                id: 'konsultaciya-s-yuristom-po-nedvizhimosti',
                                displayName: 'Консультация с юристом',
                                device: { desktop: true, mobile: true },
                                path: '/legal-advice/',
                                icon: '',
                            },
                            {
                                id: '69303be9058478f484621915',
                                displayName: 'Подготовка ДКП',
                                device: { desktop: true, mobile: true },
                                path: '/services/dkp/',
                                icon: '',
                            },
                        ],
                    },
                ],
            },
            {
                id: 'REALTORS',
                displayName: 'Риелторам и агентствам',
                displayNameMobile: 'Для профи',
                device: { desktop: true, mobile: true },
                path: '/rieltoram/',
                icon: '',
                dropdownMenu: [
                    {
                        id: '67594246852e8ac9d214a4fd',
                        displayName: 'M2Pro Новостройки',
                        device: { desktop: true, mobile: true },
                        url: '/rieltoram/m2pro-novostroyki/',
                        icon: 'm2-magnifier',
                    },
                    {
                        id: '634569648a92e72824a8807a',
                        displayName: 'Ипотека',
                        device: { desktop: true, mobile: true },
                        path: '/rieltoram/ipoteka/',
                        icon: 'm2-percentage-circle',
                    },
                    {
                        id: '634569838a92e72824a8807c',
                        displayName: 'Сделка',
                        device: { desktop: true, mobile: true },
                        path: '/rieltoram/online-sdelka/',
                        icon: 'note-sign',
                        dropdownMenu: [
                            {
                                id: '69bd3fbd0e3ef0d914af6a4c',
                                displayName: 'Сделки в офисе',
                                device: { desktop: true, mobile: true },
                                path: '/rieltoram/online-sdelka/',
                                icon: '',
                                exact: true,
                            },
                            {
                                id: '69bd1b9ba68246c0293aaa05',
                                displayName: 'Дистанционные сделки',
                                device: { desktop: true, mobile: true },
                                path: '/rieltoram/online-sdelka/transregional/',
                                icon: '',
                                exact: true,
                            },
                        ],
                    },
                    {
                        id: '6345699b8a92e72824a8807e',
                        displayName: 'Сервисы',
                        device: { desktop: true, mobile: true },
                        icon: 'm2-star',
                        dropdownMenu: [
                            {
                                id: '634569ac8a92e72824a88080',
                                displayName: 'Сервис безопасных расчётов',
                                device: { desktop: true, mobile: true },
                                path: '/rieltoram/sbr/',
                                icon: '',
                            },
                            {
                                id: '634569bd8a92e72824a88082',
                                displayName: 'Электронная регистрация',
                                device: { desktop: true, mobile: true },
                                path: '/rieltoram/elreg/',
                                icon: '',
                            },
                            {
                                id: '6846edae273f3de9120e3113',
                                displayName: 'Электронная регистрация для юрлиц',
                                device: { desktop: true, mobile: true },
                                path: '/rieltoram/podacha-dokumentov-v-rosreestr-dlya-yul/',
                                icon: '',
                            },
                        ],
                    },
                    {
                        id: 'yuridicheskie-servisi',
                        displayName: 'Юридические сервисы',
                        device: { desktop: true, mobile: true },
                        icon: '',
                        dropdownMenu: [
                            {
                                id: 'proverka',
                                displayName: 'Проверка недвижимости',
                                device: { desktop: true, mobile: true },
                                path: '/rieltoram/proverka/',
                                icon: '',
                            },
                            {
                                id: 'ekspress-proverka',
                                displayName: 'Экспресс-проверка',
                                device: { desktop: true, mobile: true },
                                path: '/services/checkup/',
                                icon: '',
                            },
                            {
                                id: 'zaschita-sdelki',
                                displayName: 'Защита сделки',
                                device: { desktop: true, mobile: true },
                                path: '/rieltoram/guaranteed-deal/',
                                icon: '',
                            },
                            {
                                id: 'konsultaciya-s-yuristom-po-nedvizhimosti',
                                displayName: 'Консультация с юристом',
                                device: { desktop: true, mobile: true },
                                path: '/legal-advice/',
                                icon: '',
                            },
                            {
                                id: '69303c42058478f484621942',
                                displayName: 'Подготовка ДКП',
                                device: { desktop: true, mobile: true },
                                path: '/services/dkp/',
                                icon: '',
                            },
                        ],
                    },
                    {
                        id: '63456a3e8a92e72824a8808a',
                        displayName: 'Обучение',
                        device: { desktop: true, mobile: true },
                        icon: 'calendar',
                        dropdownMenu: [
                            {
                                id: '668feeb43dd22e52f8ecc88c',
                                displayName: 'Мероприятия',
                                device: { desktop: true, mobile: true },
                                path: '/events/',
                                icon: '',
                            },
                            {
                                id: '67c08574d688e768dce933d5',
                                displayName: 'Тренинги и курсы',
                                device: { desktop: true, mobile: true },
                                path: '/rieltoram/treningi-i-kursi/',
                                icon: '',
                            },
                        ],
                    },
                    {
                        id: 'rieltoram-rating',
                        displayName: 'Рейтинг',
                        device: { desktop: true, mobile: true },
                        path: '/rieltoram/rating/',
                        icon: '',
                    },
                    {
                        id: '691c70cc058478f484518d43',
                        displayName: 'Наши партнёры',
                        device: { mobile: true, desktop: false },
                        path: '/partners/',
                        icon: '',
                    },
                    {
                        id: '691c7107058478f484518d70',
                        displayName: 'Юридические лица',
                        device: { mobile: true, desktop: false },
                        icon: '',
                        dropdownMenu: [
                            {
                                id: '691c714b058478f484518da0',
                                displayName: 'Изменения в регистрации сделок',
                                device: { mobile: true, desktop: false },
                                path: '/izmeneniya-v-elektronnoj-registracii-sdelok-yul/',
                                icon: '',
                            },
                            {
                                id: '691c7124058478f484518d7f',
                                displayName: 'Электронная регистрация для юридических лиц',
                                device: { mobile: true, desktop: false },
                                path: '/elektronnaya-registraciya-sdelok-yul/',
                                icon: '',
                            },
                        ],
                    },
                    {
                        id: '691c7174058478f484518dc1',
                        displayName: 'Амбассадоры',
                        device: { mobile: true, desktop: false },
                        url: 'https://am2ssador.m2.ru/',
                        icon: '',
                        target: '_blank',
                    },
                ],
            },
            {
                id: 'PARTNERS',
                displayName: 'Партнёрам',
                device: { desktop: true, mobile: false },
                path: '/partners/',
                icon: '',
                dropdownMenu: [
                    {
                        id: '63456b048a92e72824a88095',
                        displayName: 'Наши партнёры',
                        device: { desktop: true, mobile: false },
                        path: '/partners/',
                        icon: '',
                    },
                    {
                        id: '67e65c81ba3ebd120718a668',
                        displayName: 'Юридические лица',
                        device: { desktop: true, mobile: false },
                        icon: '',
                        dropdownMenu: [
                            {
                                id: '67ea9e5fad77286871708fc3',
                                displayName: 'Электронная регистрация для юридических лиц',
                                device: { desktop: true, mobile: false },
                                path: '/elektronnaya-registraciya-sdelok-yul/',
                                icon: '',
                            },
                            {
                                id: '67ea9eb0ad7728687170900c',
                                displayName: 'Изменения в регистрации сделок',
                                device: { desktop: true, mobile: false },
                                path: '/izmeneniya-v-elektronnoj-registracii-sdelok-yul/',
                                icon: '',
                            },
                            {
                                id: '6989a64b9cfc3245b339abe9',
                                displayName: 'Брокер ИЖС',
                                device: { desktop: true, mobile: false },
                                path: '/brokerizhs/',
                                icon: '',
                            },
                        ],
                    },
                    {
                        id: '646340fecd286f0048fb0868',
                        displayName: 'Амбассадоры',
                        device: { desktop: true, mobile: false },
                        url: 'https://am2ssador.m2.ru/',
                        icon: 'lightning-circle',
                        target: '_blank',
                    },
                ],
            },
        ],
        partners: {
            media: {
                regionIds: [
                    9514, 23503, 40764, 6565, 171367, 123396, 741, 2025, 763, 494, 3522, 1999, 2296, 3304, 649, 3810,
                    1355, 3409, 755, 12394, 585, 958, 12064, 792, 2674231, 3273, 1201, 1302, 1332, 3845, 1959, 5258,
                    1308, 5145, 4598, 46369, 5403, 4771, 1247, 1182, 3337, 1970, 27698, 991, 3895, 1362, 706, 40173,
                    869, 1096, 2288, 2796, 677, 1259, 982, 3492, 4941, 37866, 181292, 3948, 4381, 2814, 30400, 59352,
                    1042, 169866, 4705, 1113, 22045, 2522732, 444, 886, 9513, 3, 108,
                ],
                id: 'media',
                logo: 'https://cdn.m2.ru/assets/file-upload-server/66fd593306f28377fc1e190a037e930e.svg',
                logoWhite: 'https://cdn.m2.ru/assets/file-upload-server/afa0437b1a71bb41d7a2a281edfacb42.svg',
                url: '/media/',
                analyticsDataClick: 'media-logo-click',
            },
        },
        personalButtons: {},
        loginPaths: {
            default: { id: 'default-login', url: '/login/' },
            client: { id: 'login-client', url: '/login/client/' },
            professional: { id: 'login-professional', url: '/login/professional/' },
            partner: { url: '/login/partner/', id: 'login-partner' },
        },
        logoHref: '/novosibirsk/',
    },
    footer: {
        downloadAppQrCode: 'https://cdn.m2.ru/assets/file-upload-server/5f03bb1725f314b8c9e8f175437817b4.svg',
        top: [
            [
                { name: 'О компании', href: '/about/', cdn: false, analytics: 'footerLinkAbout' },
                { name: 'Вакансии', href: '/vacancies/', cdn: false, analytics: 'footerLinkVacancies' },
                { name: 'ИТ-деятельность', href: '/it/', cdn: false, analytics: 'footerLinkIT' },
                { name: 'Помощь', href: '/support/', cdn: false, analytics: 'footerLinkSupport' },
                { name: 'Наши партнёры', href: '/partners/', cdn: false, analytics: 'footerLinkPartners' },
                { name: 'М2 Медиа', href: '/media/', cdn: false, analytics: 'footerLinkNews' },
                { name: 'Новости М2', href: '/pr/', cdn: false, analytics: 'footerLinkPr' },
            ],
            [
                {
                    name: 'Правила оплаты',
                    href: '/assets/pdfs/oplata-onlain.pdf',
                    cdn: true,
                    analytics: 'footerLinkPaymentRules',
                },
                {
                    target: '_blank',
                    name: 'Закупки',
                    href: 'https://bidzaar.com/publicprofile/index/54eee136-f189-4823-8b5c-5dc58589d1d0',
                    cdn: false,
                    analytics: 'footerLinkTender',
                },
                {
                    name: 'Клиентские документы',
                    href: '/doc/clients/',
                    cdn: false,
                    analytics: 'footerLinkSoglasheniya',
                },
                {
                    name: 'Безопасность данных',
                    href: '/data-security/',
                    cdn: false,
                    analytics: 'footerLinkDataSecurity',
                },
            ],
        ],
        middleLinks: [
            {
                title: 'Частным лицам',
                links: [
                    {
                        name: 'Новостройки',
                        href: '/novosibirsk/novostroyki/',
                        analytics: 'footerLinkNovostroyki',
                        linkGenerationId: 'new-buildings',
                    },
                    { name: 'Ипотека', href: '/ipoteka/', analytics: 'footerLinkIpoteka' },
                    {
                        name: 'Ипотечный калькулятор',
                        href: '/ipoteka/calculator/',
                        analytics: 'footerLinkIpotechyjKalkulyator',
                    },
                    { name: 'Сделка', href: '/services/deal/', analytics: 'footerDeal' },
                    { name: 'Защита сделки', href: '/services/guaranteed-deal/', analytics: 'footerGuaranteedDeal' },
                    {
                        name: 'Проверка недвижимости',
                        href: '/services/proverka-yuridicheskoy-chistoty-kvartiry/',
                        analytics: 'footerLinkProverka',
                    },
                ],
            },
            {
                title: 'Риелторам и агентствам',
                links: [
                    {
                        name: 'Новостройки',
                        href: '/novosibirsk/novostroyki/',
                        analytics: 'footerLinkNovostroyki',
                        linkGenerationId: 'new-buildings',
                    },
                    { name: 'Ипотека', href: '/rieltoram/ipoteka/' },
                    { name: 'Сделка', href: '/rieltoram/online-sdelka/' },
                    { name: 'Сервис безопасных расчётов', href: '/rieltoram/sbr/' },
                    { name: 'Электронная регистрация', href: '/rieltoram/elreg/' },
                    { name: 'Защита сделки', href: '/rieltoram/guaranteed-deal/' },
                    { name: 'Проверка недвижимости', href: '/rieltoram/proverka/', analytics: 'footerLinkProverka' },
                    { name: 'Мероприятия', href: '/events/' },
                    { name: 'M2Pro Новостройки', href: '/rieltoram/m2pro-novostroyki/' },
                ],
            },
            {
                title: 'Партнёрам',
                links: [
                    { name: 'Брокер ИЖС', href: '/brokerizhs/' },
                    { name: 'Электронная регистрация для ЮЛ', href: '/elektronnaya-registraciya-sdelok-yul/' },
                    { name: 'Безопасные расчёты для ЮЛ', href: '/elektronnaya-registraciya-sdelok-yul/' },
                ],
            },
        ],
        socialLinks: [
            { name: 'ВКонтакте', icon: 'vk', href: 'https://vk.ru/metr_kvadratnyy' },
            { name: 'Telegram', icon: 'telegram', href: 'https://t.me/metrkvadratny/' },
            { name: 'Max', icon: 'max', href: 'https://max.ru/m2rieltor' },
        ],
        apps: [
            {
                href: 'https://trk.mail.ru/c/htywr2?mt_gaid={mt_gaid}&mt_campaign=web_footer',
                analytics: 'FooterLinkRuStore',
                imgSrc: '/assets/file-upload-server/ae1d8607969769407f91a9897e61121b.svg',
            },
            {
                href: 'https://trk.mail.ru/c/n9fk639?mt_gaid={mt_gaid}&mt_campaign=web_footer',
                analytics: 'FooterLinkHuawei',
                imgSrc: '/assets/file-upload-server/f24c8e5b58b995f37dc1afcb386456f6.svg',
            },
            {
                href: 'https://trk.mail.ru/c/ygrxv6?mt_gaid={mt_gaid}&mt_campaign=web_footer',
                analytics: 'FooterLinkGetApps',
                imgSrc: '/assets/file-upload-server/d1531d4256a615f155f41b47c9696015.svg',
            },
            {
                href: 'https://trk.mail.ru/c/gkklf3?mt_gaid=%7Bmt_gaid%7D&mt_campaign=web_footer',
                analytics: 'FooterLinkGalaxy',
                imgSrc: '/assets/file-upload-server/4dc08b404fc6f2c59c48afb176afe08f.svg',
            },
        ],
        logoHref: '/novosibirsk/',
    },
    navbar: {
        menuItems: {
            CLIENT: [
                { href: '/personal-area', icon: 'house', analytics: '', title: 'Кабинет', action: '', payload: {} },
                {
                    href: '/personal-area/services/',
                    icon: 'm2-squares-quad',
                    analytics: '',
                    title: 'Сервисы',
                    action: '',
                    payload: {},
                },
                {
                    href: '',
                    icon: 'm2-chat',
                    analytics: '',
                    title: 'Чаты',
                    action: 'chat:open',
                    payload: { 'chatId:': 'chat-list' },
                },
            ],
            PROFESSIONAL: [
                { href: '/personal-area', icon: 'house', analytics: '', title: 'Кабинет', action: '', payload: {} },
                {
                    href: '/personal-area/services',
                    icon: 'm2-squares-quad',
                    analytics: '',
                    title: 'Сервисы',
                    action: '',
                    payload: {},
                },
                {
                    href: '/personal-area/all-deals',
                    icon: 'm2-folder-clip',
                    analytics: '',
                    title: 'Заявки',
                    action: '',
                    payload: {},
                },
                {
                    href: '',
                    icon: 'm2-chat',
                    analytics: '',
                    title: 'Чаты',
                    action: 'chat:open',
                    payload: { 'chatId:': 'chat-list' },
                },
            ],
            REALTOR: [
                { href: '/personal-area', icon: 'house', analytics: '', title: 'Кабинет', action: '', payload: {} },
                {
                    href: '/personal-area/services',
                    icon: 'm2-squares-quad',
                    analytics: '',
                    title: 'Сервисы',
                    action: '',
                    payload: {},
                },
                {
                    href: '/personal-area/all-deals',
                    icon: 'm2-folder-clip',
                    analytics: '',
                    title: 'Заявки',
                    action: '',
                    payload: {},
                },
                {
                    href: '',
                    icon: 'm2-chat',
                    analytics: '',
                    title: 'Чаты',
                    action: 'chat:open',
                    payload: { 'chatId:': 'chat-list' },
                },
            ],
            BANK: [],
        },
    },
};
